import { useNavigate } from "react-router-dom"

export function useAccessAPI(apiMethod) {
    const navigate = useNavigate()

    return async function() {
        const response = await apiMethod(...arguments)
        if (response?.status === 401) {
            navigate('/auth')
            return
        }
        return response
    }
}
